export const GET_MY_STORES_START = 'GET_MY_STORES_START';
export const GET_MY_STORES_SUCCESS = 'GET_MY_STORES_SUCCESS';
export const GET_MY_STORES_ERROR = 'GET_MY_STORES_ERROR';
export const GET_MY_STORES_END = 'GET_MY_STORES_END';
